var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTalentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8569",
    "data-name": "Group 8569",
    transform: "translate(-20 -21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_68",
    "data-name": "Polygon 68",
    d: "M10.22,2.1a1.5,1.5,0,0,1,2.56,0L15.2,6.06a1.5,1.5,0,0,0,.926.676l4.51,1.094a1.5,1.5,0,0,1,.791,2.427l-3.018,3.562A1.5,1.5,0,0,0,18.06,14.9l.359,4.657a1.5,1.5,0,0,1-2.071,1.5l-4.273-1.775a1.5,1.5,0,0,0-1.151,0L6.652,21.062a1.5,1.5,0,0,1-2.071-1.5L4.94,14.9a1.5,1.5,0,0,0-.351-1.085L1.571,10.258A1.5,1.5,0,0,1,2.362,7.83l4.51-1.094A1.5,1.5,0,0,0,7.8,6.06Z",
    transform: "translate(20 21)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_Perm_Identity_Sharp",
    "data-name": "Icon / Perm Identity / Sharp",
    transform: "translate(24.574 26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1990",
    "data-name": "Path 1990",
    d: "M966.926-68a1.463,1.463,0,0,0-1.463,1.463,1.463,1.463,0,0,0,1.463,1.463,1.463,1.463,0,0,0,1.463-1.463A1.463,1.463,0,0,0,966.926-68Zm0,3.292c-.977,0-2.926.49-2.926,1.463v1.1h5.853v-1.1C969.853-64.218,967.9-64.708,966.926-64.708Z",
    transform: "translate(-960 72)",
    fill: "#040227"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentIcon);
export default __webpack_public_path__ + "static/media/talent-icon.db54a41da101c414134f9c497d22057a.svg";
export { ForwardRef as ReactComponent };